import useApi from 'assets/hooks/api/useApi';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import PayeeType from 'models/claims/payeeType/Model.PayeeType';
import Dealer from 'models/dealerManagement/dealer/Model.Dealer';
import Payee from 'models/claims/payee/Model.Payee';

export default function useClaimCreator() {
  const { user, permissions } = useAuthStore();

  const isClaimAdmin = permissions?.CLAIM_ADMIN;
  const canCreateClaim = isClaimAdmin || permissions?.CREATE_CLAIM;
  const canCreateClaimForExpiredContract = isClaimAdmin || permissions?.CREATE_CLAIM_FOR_EXPIRED_CONTRACT;
  const canCreateSimpleClaim = isClaimAdmin || permissions?.CREATE_SIMPLE_CLAIM;

  const repairFacilityListApi = useApi({
    action: Payee.list,
    default: { payeeTypeId: [PayeeType.REPAIR_FACILITY_ID], orderBy: 'name', orderType: 'asc' },
  });
  const dealerListApi = useApi({
    action: Dealer.list,
    default: {
      id: user?.dealers?.map((d) => d.id) ?? undefined,
      distributorId: user?.distributorId ? [user?.distributorId] : undefined,
      orderBy: 'name',
      orderType: 'asc',
    },
  });

  return {
    canCreateClaim,
    canCreateSimpleClaim,
    canCreateClaimForExpiredContract,
    dealerListApi,
    repairFacilityListApi,
  };
}
